(function () {
  'use strict';

  /* @ngdoc object
   * @name trainingDiscrepancy
   * @description
   *
   */
  angular
    .module('trainingDiscrepancy', [
      'ui.router'
    ]);
}());
